import React from 'react';

type PinIconProps = {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  className?: string;
};

export function PinIcon({ onClick, className = '' }: PinIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M10.8333 1.66667L18.3333 9.16667L15.8333 11.6667L12.5 8.33333L11.6667 15L9.16667 17.5L8.33333 11.6667L2.5 10.8333L5 8.33333L11.6667 7.5L8.33333 4.16667L10.8333 1.66667Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PinIcon;
